module.exports = __webpack_public_path__ + "static/img/bg_china_map_relief_dark.1edd79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/bg_china_map_relief_dark.png
// module id = IR8w
// module chunks = 1